import React from 'react';


import MultiButtonSwitch from '../common/editors/MultiButtonSwitch';

// Powertrain applies to all model types (family, model, submodel).
// Enum mirrors `powertrain` in model/schemas/schemaModel.js
export default function ModelPowertrainSelector({ value, onChange, ... props }) {
  const options = ['ICE', 'MHEV', 'HEV', 'PHEV', 'EV', 'FCEV', 'mixed'];

  return <MultiButtonSwitch value={value} onChange={onChange} options={options} nullable={true} {... props}/>
}
